import React from 'react'
import DocumentTitle from 'src/components/document-title'
import Logo from 'src/components/home-logo'

const Home = () => (
  <DocumentTitle title="Home">
    <Logo />
  </DocumentTitle>
)

export default Home



// WEBPACK FOOTER //
// ./src/view/home/index.tsx